module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("PNL")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("PNL")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticStyle: {
      "padding-left": "20px",
      "padding-right": "20px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Pilih Toko"
    },
    on: {
      "change": _vm.handleSelect1
    },
    model: {
      value: (_vm.toko1),
      callback: function($$v) {
        _vm.toko1 = $$v
      },
      expression: "toko1"
    }
  }, _vm._l((_vm.region), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item
      }
    })
  }), 1), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "month",
      "placeholder": "Pilih Bulan"
    },
    on: {
      "change": _vm.handleChangeDate
    },
    model: {
      value: (_vm.value4),
      callback: function($$v) {
        _vm.value4 = $$v
      },
      expression: "value4"
    }
  }), _vm._v("\n                               \n                              "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "type": "success",
      "icon": "el-icon-search",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.getData()
      }
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h3', [(_vm.judul.indexOf('Periode') > -1) ? _c('b', [_vm._v(_vm._s(_vm.judul))]) : _c('b')])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('b', [_vm._v("SALES REVENUE")]), _vm._v("  \n                        "), (_vm.level.indexOf('ADMIN') !== -1 && _vm.pnl.status === 'UNLOCKED') ? _c('a', {
    staticClass: "ling",
    on: {
      "click": function($event) {
        return _vm.addSalesManual()
      }
    }
  }, [_c('i', [_vm._v("klik disini untuk input data sales manual")])]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    staticClass: "debet",
    attrs: {
      "span": 10,
      "align": "right"
    }
  }, [_c('b', [_vm._v("Rp. " + _vm._s(_vm.toMoney(_vm.pnl.sales)))]), _vm._v(" \n                      ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('i', [_vm._v("Sales System")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "align": "right"
    }
  }, [_c('i', [_vm._v("Rp. " + _vm._s(_vm.toMoney(_vm.pnl.sales_by_system)))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_vm._v(" ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('i', [_vm._v("Sales Manual")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "align": "right"
    }
  }, [_c('i', [_vm._v("Rp. " + _vm._s(_vm.toMoney(_vm.pnl.sales_manual)))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_vm._v(" ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('i', [_vm._v("Other Income  "), (_vm.level.indexOf('ADMIN') !== -1 && _vm.pnl.status === 'UNLOCKED') ? _c('a', {
    staticClass: "ling",
    on: {
      "click": function($event) {
        return _vm.addOtherIncome()
      }
    }
  }, [_c('i', [_vm._v("klik untuk input")])]) : _vm._e()])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "align": "right"
    }
  }, [_c('i', [_vm._v("Rp. " + _vm._s(_vm.toMoney(_vm.pnl.other_income)))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_vm._v(" ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('b', [_vm._v("SALES COST")]), _vm._v("  \n                        "), (_vm.level.indexOf('ADMIN') !== -1 && _vm.pnl.status === 'UNLOCKED') ? _c('a', {
    staticClass: "ling",
    on: {
      "click": function($event) {
        return _vm.addSalesCost()
      }
    }
  }, [_c('i', [_vm._v("klik disini untuk input data")])]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    staticClass: "kredit",
    attrs: {
      "span": 10,
      "align": "right"
    }
  }, [_c('b', [_vm._v("Rp. " + _vm._s(_vm.toMoney(_vm.pnl.sales_cost)))]), _vm._v(" \n                      ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg"
  }, [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('h4', [_c('b', [_vm._v(" NET SALES")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10,
      "align": "right"
    }
  }, [_c('h4', [_c('b', [_vm._v("Rp. " + _vm._s(_vm.toMoney(parseFloat(_vm.pnl.sales) - parseFloat(_vm.pnl.sales_cost))) + " ")])])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('b', [_vm._v("ROYALTI 0.75% ")]), _c('i', [_vm._v("dihitung dari NET SALES")])]), _vm._v(" "), _c('el-col', {
    staticClass: "kredit",
    attrs: {
      "span": 10,
      "align": "right"
    }
  }, [_c('b', [_vm._v("Rp. " + _vm._s(_vm.toMoney(_vm.pnl.royalti)))]), _vm._v(" \n                      ")])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [(parseFloat(_vm.pnl.cogs) > -1) ? _c('b', [_vm._v("COGS (" + _vm._s(((parseFloat(_vm.pnl.cogs) / parseFloat(_vm.pnl.sales)) * 100).toFixed(2).replace(/\.0+$/, '')) + "%)")]) : _c('b', [_vm._v("COGS")])]), _vm._v(" "), _c('el-col', {
    staticClass: "kredit",
    attrs: {
      "span": 10,
      "align": "right"
    }
  }, [_c('b', [_vm._v("Rp. " + _vm._s(_vm.toMoney(_vm.pnl.cogs)))]), _vm._v(" \n                      ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [(parseFloat(_vm.pnl.cogs_harian) > -1) ? _c('i', [_vm._v("COGS Harian (" + _vm._s(((parseFloat(_vm.pnl.cogs_harian) / parseFloat(_vm.pnl.sales)) * 100).toFixed(2).replace(/\.0+$/, '')) + "%)")]) : _c('i', [_vm._v("COGS Harian")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "align": "right"
    }
  }, [_c('i', [_vm._v("Rp. " + _vm._s(_vm.toMoney(_vm.pnl.cogs_harian)))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_vm._v(" ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [(parseFloat(_vm.pnl.cogs_bulanan) > -1) ? _c('i', [_vm._v("COGS Bulanan (" + _vm._s(((parseFloat(_vm.pnl.cogs_bulanan) / parseFloat(_vm.pnl.sales)) * 100).toFixed(2).replace(/\.0+$/, '')) + "%)")]) : _c('i', [_vm._v("COGS Bulanan")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "align": "right"
    }
  }, [_c('i', [_vm._v("Rp. " + _vm._s(_vm.toMoney(_vm.pnl.cogs_bulanan)))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_vm._v(" ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg"
  }, [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('h4', [(parseFloat(_vm.pnl.sales) > 0) ? _c('b', [_vm._v(" LABA KOTOR (" + _vm._s(((parseFloat(_vm.pnl.laba_kotor) / parseFloat(_vm.pnl.sales)) * 100).toFixed(2).replace(/\.0+$/, '')) + "%)")]) : _c('b', [_vm._v(" LABA KOTOR")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10,
      "align": "right"
    }
  }, [_c('h4', [_c('b', [_vm._v("Rp. " + _vm._s(_vm.toMoney(_vm.pnl.laba_kotor)) + " ")])])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [(parseFloat(_vm.pnl.cost) > -1) ? _c('b', [_vm._v("COST (" + _vm._s(((parseFloat(_vm.pnl.cost) / parseFloat(_vm.pnl.sales)) * 100).toFixed(2).replace(/\.0+$/, '')) + "%)")]) : _c('b', [_vm._v("COST")])]), _vm._v(" "), _c('el-col', {
    staticClass: "kredit",
    attrs: {
      "span": 10,
      "align": "right"
    }
  }, [_c('b', [_vm._v("Rp. " + _vm._s(_vm.toMoney(_vm.pnl.cost)))]), _vm._v(" \n                      ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [(parseFloat(_vm.pnl.cost_harian) > -1) ? _c('i', [_vm._v("COST Harian (" + _vm._s(((parseFloat(_vm.pnl.cost_harian) / parseFloat(_vm.pnl.sales)) * 100).toFixed(2).replace(/\.0+$/, '')) + "%)")]) : _c('i', [_vm._v("COST Harian")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "align": "right"
    }
  }, [_c('i', [_vm._v("Rp. " + _vm._s(_vm.toMoney(_vm.pnl.cost_harian)))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_vm._v(" ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [(parseFloat(_vm.pnl.cost_bulanan) > -1) ? _c('i', [_vm._v("COST Bulanan (" + _vm._s(((parseFloat(_vm.pnl.cost_bulanan) / parseFloat(_vm.pnl.sales)) * 100).toFixed(2).replace(/\.0+$/, '')) + "%)")]) : _c('i', [_vm._v("COST Bulanan")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "align": "right"
    }
  }, [_c('i', [_vm._v("Rp. " + _vm._s(_vm.toMoney(_vm.pnl.cost_bulanan)))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_vm._v(" ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg"
  }, [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('h4', [(parseFloat(_vm.pnl.sales) > 0) ? _c('b', [_vm._v(" OPERASIONAL PROFIT (" + _vm._s(((parseFloat(_vm.pnl.opr_profit) / parseFloat(_vm.pnl.sales)) * 100).toFixed(2).replace(/\.0+$/, '')) + "%)")]) : _c('b', [_vm._v(" OPERASIONAL PROFIT")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10,
      "align": "right"
    }
  }, [_c('h4', [_c('b', [_vm._v("Rp. " + _vm._s(_vm.toMoney(_vm.pnl.opr_profit).replace(/\.0+$/, '')) + " ")])])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('b', [_vm._v("TAX")])]), _vm._v(" "), _c('el-col', {
    staticClass: "kredit",
    attrs: {
      "span": 10,
      "align": "right"
    }
  }, [_c('b', [_vm._v("Rp. " + _vm._s(_vm.toMoney(_vm.pnl.tax[0].total).replace(/\.0+$/, '')))]), _vm._v(" \n                      ")])], 1), _vm._v(" "), _vm._l((_vm.pajak), function(value) {
    return _c('el-row', [_c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('i', [_vm._v(_vm._s(value.key))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4,
        "align": "right"
      }
    }), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 16
      }
    }, [_vm._v(" ")])], 1)
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('b', [_vm._v("SAVING")])]), _vm._v(" "), _c('el-col', {
    staticClass: "kredit",
    attrs: {
      "span": 10,
      "align": "right"
    }
  }, [_c('b', [_vm._v("Rp. " + _vm._s(_vm.toMoney(_vm.pnl.saving[0].total).replace(/\.0+$/, '')))]), _vm._v(" \n                      ")])], 1), _vm._v(" "), _vm._l((_vm.saving), function(value) {
    return _c('el-row', [_c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('i', [_vm._v(_vm._s(value.key))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4,
        "align": "right"
      }
    }, [_c('i', [_vm._v("Rp. " + _vm._s(_vm.toMoney(value.value).replace(/\.0+$/, '')))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 16
      }
    }, [_vm._v(" ")])], 1)
  }), _vm._v(" "), (!this.arrKodeWilayahFormatJkt.includes(this.pnl.kode_wilayah)) ? _c('hr') : _vm._e(), _vm._v(" "), (!this.arrKodeWilayahFormatJkt.includes(this.pnl.kode_wilayah)) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('b', [_vm._v("INFAQ, PRIVE, LAINNYA")]), _vm._v("  \n                        "), (_vm.level.indexOf('ADMIN') !== -1 && _vm.pnl.status === 'UNLOCKED') ? _c('a', {
    staticClass: "ling",
    on: {
      "click": function($event) {
        return _vm.addInfaq()
      }
    }
  }, [_c('i', [_vm._v("klik disini untuk input data")])]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    staticClass: "kredit",
    attrs: {
      "span": 10,
      "align": "right"
    }
  }, [_c('b', [_vm._v("Rp. " + _vm._s(_vm.toMoney(_vm.pnl.ipl[0].total).replace(/\.0+$/, '')))]), _vm._v(" \n                      ")])], 1) : _vm._e(), _vm._v(" "), (!this.arrKodeWilayahFormatJkt.includes(this.pnl.kode_wilayah)) ? _c('el-row', _vm._l((_vm.infaq), function(value) {
    return _c('el-row', [_c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('i', [_vm._v(_vm._s(value.key))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4,
        "align": "right"
      }
    }, [_c('i', [_vm._v("Rp. " + _vm._s(_vm.toMoney(value.value).replace(/\.0+$/, '')))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 16
      }
    }, [_vm._v(" ")])], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg"
  }, [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('h4', [(parseFloat(_vm.pnl.sales) > 0) ? _c('b', [_vm._v(" NET PROFIT (" + _vm._s(((parseFloat(_vm.pnl.nett_profit) / parseFloat(_vm.pnl.sales)) * 100).toFixed(2).replace(/\.0+$/, '')) + "%)")]) : _c('b', [_vm._v(" NET PROFIT")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10,
      "align": "right"
    }
  }, [_c('h4', [_c('b', [_vm._v("Rp. " + _vm._s(_vm.toMoney(_vm.pnl.nett_profit).replace(/\.0+$/, '')) + " ")])])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), (this.arrKodeWilayahFormatJkt.includes(this.pnl.kode_wilayah)) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('b', [_vm._v("INFAQ, PRIVE, LAINNYA")]), _vm._v("  \n                        "), (_vm.level.indexOf('ADMIN') !== -1 && _vm.pnl.status === 'UNLOCKED') ? _c('a', {
    staticClass: "ling",
    on: {
      "click": function($event) {
        return _vm.addInfaq()
      }
    }
  }, [_c('i', [_vm._v("klik disini untuk input data")])]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    staticClass: "kredit",
    attrs: {
      "span": 10,
      "align": "right"
    }
  }, [_c('b', [_vm._v("Rp. " + _vm._s(_vm.toMoney(_vm.pnl.ipl[0].total).replace(/\.0+$/, '')))]), _vm._v(" \n                      ")])], 1) : _vm._e(), _vm._v(" "), (this.arrKodeWilayahFormatJkt.includes(this.pnl.kode_wilayah)) ? _c('el-row', _vm._l((_vm.infaq), function(value) {
    return _c('el-row', [_c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('i', [_vm._v(_vm._s(value.key))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4,
        "align": "right"
      }
    }, [_c('i', [_vm._v("Rp. " + _vm._s(_vm.toMoney(value.value).replace(/\.0+$/, '')))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 16
      }
    }, [_vm._v(" ")])], 1)
  }), 1) : _vm._e(), _vm._v(" "), (this.arrKodeWilayahFormatJkt.includes(this.pnl.kode_wilayah)) ? _c('hr') : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('b', [_vm._v("FEE KONTROL KACAB")]), _vm._v("  \n                        "), (_vm.level.indexOf('ADMIN') !== -1 && _vm.pnl.status === 'UNLOCKED') ? _c('a', {
    staticClass: "ling",
    on: {
      "click": function($event) {
        return _vm.addFee()
      }
    }
  }, [_c('i', [_vm._v("klik disini untuk input data")])]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    staticClass: "kredit",
    attrs: {
      "span": 10,
      "align": "right"
    }
  }, [_c('b', [_vm._v("Rp. " + _vm._s(_vm.toMoney(_vm.pnl.fee_kontrol_kacab).replace(/\.0+$/, '')))]), _vm._v(" \n                      ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.judul.indexOf('PIZZANA') > -1) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h5', [_c('b', [_vm._v("DATA PEGAWAI TOKO")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.judul.indexOf('PIZZANA') > -1) ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModal),
      expression: "loadingModal"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "hover": "",
      "data": _vm.pegawai,
      "responsive": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "left",
      "header-align": "center",
      "label": "#",
      "min-width": "5px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? [_vm._v("\n                            " + _vm._s(scope.$index + 1) + "\n                          ")] : _vm._e()]
      }
    }], null, false, 3196844061)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "Nama",
      "header-align": "center",
      "prop": "nama"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.nama))])]
      }
    }], null, false, 3688936005)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Jabatan",
      "header-align": "center",
      "prop": "posisi",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.posisi))])]
      }
    }], null, false, 44065785)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Saham (%)",
      "header-align": "center",
      "prop": "saham",
      "min-width": "40px"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Bulan Lalu",
      "header-align": "center",
      "align": "center",
      "prop": "saham",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.saham_lalu))])]
      }
    }], null, false, 2982664667)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Bulan Ini",
      "header-align": "center",
      "align": "center",
      "prop": "saham",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticClass: "ling",
          on: {
            "click": function($event) {
              return _vm.addPegawaiSaham(scope.row.nama, scope.row.kode_pegawai, scope.row.kode_kacab, scope.row.saham)
            }
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.saham))])])]
      }
    }], null, false, 1137311755)
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Jumlah",
      "prop": "jumlah",
      "header-align": "center",
      "align": "right",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.toMoney(scope.row.jumlah)))])]
      }
    }], null, false, 3233281627)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.judul.indexOf('PIZZANA') > -1) ? _c('br') : _vm._e(), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg"
  }, [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('h4', [(parseFloat(_vm.pnl.sales) > 0) ? _c('b', [_vm._v(" " + _vm._s(this.title_lorisan) + " (" + _vm._s(((parseFloat(_vm.pnl.lorisan[0].total) / parseFloat(_vm.pnl.sales)) * 100).toFixed(2).replace(/\.0+$/, '')) + "%)")]) : _c('b', [_vm._v(" " + _vm._s(this.title_lorisan))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10,
      "align": "right"
    }
  }, [_c('h4', [_c('b', [_vm._v("Rp. " + _vm._s(_vm.toMoney(_vm.pnl.lorisan[0].total).replace(/\.0+$/, '')) + " ")])])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.judul.indexOf('PIZZANA') < 0) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h5', [_c('b', [_vm._v("DATA PEGAWAI TOKO")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.judul.indexOf('PIZZANA') < 0) ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModal),
      expression: "loadingModal"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "hover": "",
      "data": _vm.pegawai,
      "responsive": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "left",
      "header-align": "center",
      "label": "#",
      "min-width": "5px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? [_vm._v("\n                            " + _vm._s(scope.$index + 1) + "\n                          ")] : _vm._e()]
      }
    }], null, false, 3196844061)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "Nama",
      "header-align": "center",
      "prop": "nama"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.nama))])]
      }
    }], null, false, 3688936005)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Jabatan",
      "header-align": "center",
      "prop": "posisi",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.posisi))])]
      }
    }], null, false, 44065785)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Saham (%)",
      "header-align": "center",
      "prop": "saham",
      "min-width": "40px"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Bulan Lalu",
      "header-align": "center",
      "align": "center",
      "prop": "saham",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.saham_lalu))])]
      }
    }], null, false, 2982664667)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Bulan Ini",
      "header-align": "center",
      "align": "center",
      "prop": "saham",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticClass: "ling",
          on: {
            "click": function($event) {
              return _vm.addPegawaiSaham(scope.row.nama, scope.row.kode_pegawai, scope.row.kode_kacab, scope.row.saham)
            }
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.saham))])])]
      }
    }], null, false, 1137311755)
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Jumlah",
      "prop": "jumlah",
      "header-align": "center",
      "align": "right",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.toMoney(scope.row.jumlah)))])]
      }
    }], null, false, 3233281627)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.judul.indexOf('PIZZANA') < 0) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.judul.indexOf('PIZZANA') < 0) ? _c('br') : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('b', [_vm._v("CICIL HUTANG SEWA KONTRAKAN")]), _vm._v("  \n                        "), (_vm.level.indexOf('ADMIN') !== -1 && _vm.pnl.status === 'UNLOCKED') ? _c('a', {
    staticClass: "ling",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addHutang()
      }
    }
  }, [_c('i', [_vm._v("klik disini untuk input data")])]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    staticClass: "kredit",
    attrs: {
      "span": 10,
      "align": "right"
    }
  }, [_c('b', [_vm._v("Rp. " + _vm._s(_vm.toMoney(_vm.pnl.cicil_hutang_sewa_kontrakan)))]), _vm._v(" \n                      ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('i', [_vm._v("Sisa Hutang")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "align": "right"
    }
  }, [_c('i', [_vm._v("Rp. " + _vm._s(_vm.toMoney(_vm.pnl.hutang_sewa_kontrakan)))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_vm._v(" ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg"
  }, [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('h4', [_c('b', [_vm._v(" SISA LORISAN")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10,
      "align": "right"
    }
  }, [_c('h4', [_c('b', [_vm._v("Rp. " + _vm._s(_vm.toMoney(_vm.pnl.sisa_lorisan)) + " ")])])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('b', [_vm._v("LORISAN TERSIMPAN BULAN LALU")]), _vm._v("  \n                      ")]), _vm._v(" "), _c('el-col', {
    staticClass: "debet",
    attrs: {
      "span": 10,
      "align": "right"
    }
  }, [_c('b', [_vm._v("Rp. " + _vm._s(_vm.toMoney(_vm.pnl.laba_bulan_kemarin)))]), _vm._v(" \n                      ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('b', [_vm._v("SIMPAN LORISAN")]), _vm._v("  \n                        "), (_vm.level.indexOf('ADMIN') !== -1 && _vm.pnl.status === 'UNLOCKED') ? _c('a', {
    staticClass: "ling",
    on: {
      "click": function($event) {
        return _vm.addSimpanKeuntungan()
      }
    }
  }, [_c('i', [_vm._v("klik disini untuk input data")])]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    staticClass: "kredit",
    attrs: {
      "span": 10,
      "align": "right"
    }
  }, [_c('b', [_vm._v("Rp. " + _vm._s(_vm.toMoney(_vm.pnl.laba_bulan_ini)))]), _vm._v(" \n                      ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_c('b', [_vm._v("DATA INVESTOR TOKO")])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModal),
      expression: "loadingModal"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "hover": "",
      "data": _vm.investor,
      "responsive": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "left",
      "header-align": "center",
      "label": "#",
      "min-width": "5px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? [_vm._v("\n                            " + _vm._s(scope.$index + 1) + "\n                          ")] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "Nama",
      "header-align": "center",
      "prop": "nama"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.nama))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Saham (%)",
      "header-align": "center",
      "prop": "saham",
      "min-width": "40px"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Bulan Lalu",
      "header-align": "center",
      "align": "center",
      "prop": "saham",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.saham_lalu))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Bulan Ini",
      "header-align": "center",
      "align": "center",
      "prop": "saham",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.saham))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Jumlah",
      "header-align": "center",
      "align": "right",
      "prop": "jumlah",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.toMoney(scope.row.jumlah)))])]
      }
    }])
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8,
      "id": "noprint"
    }
  }, [(_vm.pnl.status === 'UNLOCKED' && _vm.judul.indexOf('-') > -1) ? _c('el-button', {
    attrs: {
      "width": "100px",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.lockPNL()
      }
    }
  }, [_c('b', [_vm._v("SIMPAN DATA")])]) : _vm._e(), _vm._v(" "), (_vm.pnl.status === 'LOCKED' && _vm.judul.indexOf('-') > -1) ? _c('el-button', {
    attrs: {
      "width": "100px",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.createPDF()
      }
    }
  }, [_c('b', [_vm._v("DOWNLOAD PDF")])]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v(" ")])], 1)], 2)]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalLunas),
      expression: "loadingModalLunas"
    }],
    attrs: {
      "title": "Konfirmasi",
      "visible": _vm.dialogFormLunas,
      "width": "35%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormLunas = $event
      }
    }
  }, [_c('h4', [_vm._v("Apakah Anda yakin akan melakukan pelunasan tanggal " + _vm._s(_vm.tanggal) + "-" + _vm._s(_vm.bulan) + "-" + _vm._s(_vm.tahun) + " sebesar Rp " + _vm._s(_vm.toMoney(_vm.nominal)) + " ?")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormLunas = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmLunas1()
      }
    }
  }, [_vm._v("Ya")])], 1)]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalLock),
      expression: "loadingModalLock"
    }],
    attrs: {
      "title": "Konfirmasi",
      "visible": _vm.dialogFormLock,
      "width": "35%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormLock = $event
      }
    }
  }, [_c('h4', [_vm._v("Apakah Anda yakin akan menyimpan data PnL " + _vm._s(_vm.nama_toko) + " periode " + _vm._s(_vm.tahun) + "-" + _vm._s(_vm.bulan) + " ?")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormLock = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmLock()
      }
    }
  }, [_vm._v("Ya")])], 1)]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalAdd),
      expression: "loadingModalAdd"
    }],
    attrs: {
      "title": "Tambah Saving",
      "visible": _vm.dialogFormVisible,
      "width": "35%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formAdd",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row1,
      "status-icon": "",
      "rules": _vm.rules3,
      "label-width": _vm.formLabelWidth
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tanggal",
      "prop": "tanggal"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.row1.tanggal),
      callback: function($$v) {
        _vm.$set(_vm.row1, "tanggal", $$v)
      },
      expression: "row1.tanggal"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Keterangan",
      "prop": "nama"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "Pilih Keterangan"
    },
    model: {
      value: (_vm.row1.nama),
      callback: function($$v) {
        _vm.$set(_vm.row1, "nama", $$v)
      },
      expression: "row1.nama"
    }
  }, _vm._l((_vm.namas), function(item) {
    return _c('el-option', {
      key: item.kode,
      attrs: {
        "label": item.nama,
        "value": item.nama
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Jumlah",
      "prop": "jumlah"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.row1.jumlah),
      callback: function($$v) {
        _vm.$set(_vm.row1, "jumlah", $$v)
      },
      expression: "row1.jumlah"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmEdit1(0, _vm.row1, 'formAdd')
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalEdit),
      expression: "loadingModalEdit"
    }],
    attrs: {
      "title": "Edit Wilayah",
      "visible": _vm.dialogFormEdit,
      "width": "35%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormEdit = $event
      }
    }
  }, [_c('el-form', {
    ref: "formEdit",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row1,
      "status-icon": "",
      "rules": _vm.rules3,
      "label-width": _vm.formLabelWidth
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nama",
      "prop": "nama"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.row1.nama),
      callback: function($$v) {
        _vm.$set(_vm.row1, "nama", $$v)
      },
      expression: "row1.nama"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Jumlah",
      "prop": "jumlah"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.row1.jumlah),
      callback: function($$v) {
        _vm.$set(_vm.row1, "jumlah", $$v)
      },
      expression: "row1.jumlah"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tanggal",
      "prop": "tanggal"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.row1.tanggal),
      callback: function($$v) {
        _vm.$set(_vm.row1, "tanggal", $$v)
      },
      expression: "row1.tanggal"
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalAdmin),
      expression: "loadingModalAdmin"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "hover": "",
      "data": _vm.pegawai,
      "highlight-current-row": "",
      "responsive": ""
    },
    on: {
      "current-change": _vm.handleCurrentChangePegawai
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "#",
      "min-width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(scope.$index + 1) + "\n                  ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "SKU",
      "min-width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(scope.row.sku) + "\n                  ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "Nama",
      "min-width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(scope.row.nama) + "\n                  ")]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormEdit = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmEdit1(0, _vm.row1, 'formEdit')
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalInfaq),
      expression: "loadingModalInfaq"
    }],
    attrs: {
      "title": "Input Data IPL",
      "visible": _vm.dialogFormInfaq,
      "width": "35%",
      "top": "3%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormInfaq = $event
      }
    }
  }, [_c('el-form', {
    ref: "formAdd",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row1,
      "status-icon": "",
      "rules": _vm.rules3,
      "label-width": _vm.formLabelWidth
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Pengali",
      "prop": "nett"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    model: {
      value: (_vm.pengali_ipl),
      callback: function($$v) {
        _vm.pengali_ipl = $$v
      },
      expression: "pengali_ipl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Infaq (%)",
      "prop": "infaq"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.onChangeInfaq()
      }
    },
    model: {
      value: (_vm.row1.infaq1),
      callback: function($$v) {
        _vm.$set(_vm.row1, "infaq1", $$v)
      },
      expression: "row1.infaq1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Infaq",
      "prop": "infaq"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.onChangeInfaq1()
      }
    },
    model: {
      value: (_vm.row1.infaq),
      callback: function($$v) {
        _vm.$set(_vm.row1, "infaq", $$v)
      },
      expression: "row1.infaq"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Prive (%)",
      "prop": "prive"
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.onChangePrive()
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.prive1),
      callback: function($$v) {
        _vm.$set(_vm.row1, "prive1", $$v)
      },
      expression: "row1.prive1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Prive",
      "prop": "prive"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.onChangePrive1()
      }
    },
    model: {
      value: (_vm.row1.prive),
      callback: function($$v) {
        _vm.$set(_vm.row1, "prive", $$v)
      },
      expression: "row1.prive"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Lainnya (%)",
      "prop": "lainnya"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "keyup": [function($event) {
        return _vm.onChangeLainnya()
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.confirmEdit2(0, _vm.row1, 'formAdd')
      }]
    },
    model: {
      value: (_vm.row1.lainnya1),
      callback: function($$v) {
        _vm.$set(_vm.row1, "lainnya1", $$v)
      },
      expression: "row1.lainnya1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Lainnya",
      "prop": "lainnya"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "keyup": [function($event) {
        return _vm.onChangeLainnya1()
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.confirmEdit2(0, _vm.row1, 'formAdd')
      }]
    },
    model: {
      value: (_vm.row1.lainnya),
      callback: function($$v) {
        _vm.$set(_vm.row1, "lainnya", $$v)
      },
      expression: "row1.lainnya"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormInfaq = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmEdit2(0, _vm.row1, 'formAdd')
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalSales),
      expression: "loadingModalSales"
    }],
    attrs: {
      "title": "Input Data Sales Manual",
      "visible": _vm.dialogFormSales,
      "width": "35%",
      "top": "3%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormSales = $event
      }
    }
  }, [_c('el-form', {
    ref: "formAdd",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row1,
      "status-icon": "",
      "rules": _vm.rules3,
      "label-width": _vm.formLabelWidth
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Toko",
      "prop": "nama_toko"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    model: {
      value: (_vm.nama_toko),
      callback: function($$v) {
        _vm.nama_toko = $$v
      },
      expression: "nama_toko"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Total (Rp)",
      "prop": "total"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.total_sales_manual),
      callback: function($$v) {
        _vm.total_sales_manual = $$v
      },
      expression: "total_sales_manual"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormSales = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmEdit4(0, _vm.row1, 'formAdd')
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalOtherIncome),
      expression: "loadingModalOtherIncome"
    }],
    attrs: {
      "title": "Input Data Other Income",
      "visible": _vm.dialogFormOtherIncome,
      "width": "35%",
      "top": "3%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormOtherIncome = $event
      }
    }
  }, [_c('el-form', {
    ref: "formAdd",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row1,
      "status-icon": "",
      "rules": _vm.rules3,
      "label-width": _vm.formLabelWidth
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Toko",
      "prop": "nama_toko"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    model: {
      value: (_vm.nama_toko),
      callback: function($$v) {
        _vm.nama_toko = $$v
      },
      expression: "nama_toko"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Total (Rp)",
      "prop": "total"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.total_other_income),
      callback: function($$v) {
        _vm.total_other_income = $$v
      },
      expression: "total_other_income"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormOtherIncome = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmOtherIncome(0, _vm.row1, 'formAdd')
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalSalesCost),
      expression: "loadingModalSalesCost"
    }],
    attrs: {
      "title": "Input Data Sales Cost",
      "visible": _vm.dialogFormSalesCost,
      "width": "35%",
      "top": "3%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormSalesCost = $event
      }
    }
  }, [_c('el-form', {
    ref: "formAdd",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row1,
      "status-icon": "",
      "rules": _vm.rules3,
      "label-width": _vm.formLabelWidth
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Toko",
      "prop": "nama_toko"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    model: {
      value: (_vm.nama_toko),
      callback: function($$v) {
        _vm.nama_toko = $$v
      },
      expression: "nama_toko"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Total (Rp)",
      "prop": "sc_total"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.sc_total),
      callback: function($$v) {
        _vm.sc_total = $$v
      },
      expression: "sc_total"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormSalesCost = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmSalesCost(0, _vm.row1, 'formAdd')
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalUntung),
      expression: "loadingModalUntung"
    }],
    attrs: {
      "title": "Simpan Keuntungan",
      "visible": _vm.dialogFormUntung,
      "width": "35%",
      "top": "3%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormUntung = $event
      }
    }
  }, [_c('el-form', {
    ref: "formAdd",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row1,
      "status-icon": "",
      "rules": _vm.rules3,
      "label-width": _vm.formLabelWidth
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Toko",
      "prop": "nama_toko"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    model: {
      value: (_vm.nama_toko),
      callback: function($$v) {
        _vm.nama_toko = $$v
      },
      expression: "nama_toko"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Total (Rp)",
      "prop": "total_keuntungan"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.total_keuntungan),
      callback: function($$v) {
        _vm.total_keuntungan = $$v
      },
      expression: "total_keuntungan"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormUntung = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmEdit5(0, _vm.row1, 'formAdd')
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalHutangTambah),
      expression: "loadingModalHutangTambah"
    }],
    attrs: {
      "title": "Tambah Data Hutang Sewa Toko",
      "visible": _vm.dialogFormHutangTambah,
      "width": "35%",
      "top": "3%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormHutangTambah = $event
      }
    }
  }, [_c('el-form', {
    ref: "formAdd",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row1,
      "status-icon": "",
      "rules": _vm.rules3,
      "label-width": _vm.formLabelWidth
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Toko",
      "prop": "nama_toko"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    model: {
      value: (_vm.nama_toko),
      callback: function($$v) {
        _vm.nama_toko = $$v
      },
      expression: "nama_toko"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Jumlah (Rp)",
      "prop": "jumlah"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.hutang_jumlah),
      callback: function($$v) {
        _vm.$set(_vm.row1, "hutang_jumlah", $$v)
      },
      expression: "row1.hutang_jumlah"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Keterangan",
      "prop": "keterangan"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.hutang_keterangan),
      callback: function($$v) {
        _vm.$set(_vm.row1, "hutang_keterangan", $$v)
      },
      expression: "row1.hutang_keterangan"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormHutangTambah = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmEdit6(0, _vm.row1, 'formAdd')
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalHutangCicil),
      expression: "loadingModalHutangCicil"
    }],
    attrs: {
      "title": "Tambah Data Cicilan Hutang Sewa Toko",
      "visible": _vm.dialogFormHutangCicil,
      "width": "35%",
      "top": "3%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormHutangCicil = $event
      }
    }
  }, [_c('el-form', {
    ref: "formAdd",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row1,
      "status-icon": "",
      "rules": _vm.rules3,
      "label-width": _vm.formLabelWidth
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Toko",
      "prop": "nama_toko"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    model: {
      value: (_vm.nama_toko),
      callback: function($$v) {
        _vm.nama_toko = $$v
      },
      expression: "nama_toko"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Jumlah (Rp)",
      "prop": "jumlah"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.hutang_jumlah_cicil),
      callback: function($$v) {
        _vm.$set(_vm.row1, "hutang_jumlah_cicil", $$v)
      },
      expression: "row1.hutang_jumlah_cicil"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormHutangCicil = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmEdit7(0, _vm.row1, 'formAdd')
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalHutang),
      expression: "loadingModalHutang"
    }],
    attrs: {
      "title": "Hutang Sewa Toko",
      "visible": _vm.dialogFormHutang,
      "width": "1100px",
      "top": "1%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormHutang = $event
      }
    }
  }, [_c('el-form', {
    ref: "formAdd",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row1,
      "status-icon": "",
      "rules": _vm.rules3,
      "label-width": _vm.formLabelWidth
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Toko",
      "prop": "nama_toko"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    model: {
      value: (_vm.nama_toko),
      callback: function($$v) {
        _vm.nama_toko = $$v
      },
      expression: "nama_toko"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModal),
      expression: "loadingModal"
    }],
    staticStyle: {
      "width": "100%",
      "padding-right": "1px"
    },
    attrs: {
      "border": "",
      "hover": "",
      "data": _vm.dataHutang,
      "responsive": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "#",
      "header-align": "center",
      "align": "center",
      "width": "50px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? [_vm._v("\n                        " + _vm._s(scope.$index + 1) + ".\n                      ")] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "RP",
      "prop": "jumlah",
      "header-align": "center",
      "align": "center",
      "width": "150px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? [_vm._v("\n                        " + _vm._s(_vm.toMoney(scope.row.jumlah)) + "\n                      ")] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "DB / CR",
      "prop": "qty",
      "header-align": "center",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? [_vm._v("\n                        " + _vm._s(scope.row.dbcr) + "\n                      ")] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "KETERANGAN",
      "prop": "value",
      "header-align": "center",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? [_vm._v("\n                        " + _vm._s(scope.row.keterangan) + "\n                      ")] : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormHutang = false
      }
    }
  }, [_vm._v("Tutup")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addHutangTambah()
      }
    }
  }, [_vm._v("Input Hutang")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addHutangCicil()
      }
    }
  }, [_vm._v("Input Cicilan")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalFee),
      expression: "loadingModalFee"
    }],
    attrs: {
      "title": "Input Data Fee Kontrol KACAB",
      "visible": _vm.dialogFormFee,
      "width": "35%",
      "top": "3%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormFee = $event
      }
    }
  }, [_c('el-form', {
    ref: "formAdd",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row1,
      "status-icon": "",
      "rules": _vm.rules3,
      "label-width": _vm.formLabelWidth
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Pengali",
      "prop": "nett"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    model: {
      value: (_vm.pengali_fee_kacab),
      callback: function($$v) {
        _vm.pengali_fee_kacab = $$v
      },
      expression: "pengali_fee_kacab"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Fee (%)",
      "prop": "fee"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.onChangeFeeKacabByProsentase()
      }
    },
    model: {
      value: (_vm.row1.fee1),
      callback: function($$v) {
        _vm.$set(_vm.row1, "fee1", $$v)
      },
      expression: "row1.fee1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Fee",
      "prop": "fee"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.onChangeFeeKacabByValue()
      }
    },
    model: {
      value: (_vm.row1.fee),
      callback: function($$v) {
        _vm.$set(_vm.row1, "fee", $$v)
      },
      expression: "row1.fee"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormFee = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmEdit3(0, _vm.row1, 'formAdd')
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalSahamPegawai),
      expression: "loadingModalSahamPegawai"
    }],
    attrs: {
      "title": "Saham Pegawai",
      "visible": _vm.dialogFormSahamPegawai,
      "width": "35%",
      "top": "3%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormSahamPegawai = $event
      }
    }
  }, [_c('el-form', {
    ref: "formAdd",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row1,
      "status-icon": "",
      "rules": _vm.rules3,
      "label-width": _vm.formLabelWidth
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nama",
      "prop": "nama_pegawai"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    model: {
      value: (_vm.nama_pegawai),
      callback: function($$v) {
        _vm.nama_pegawai = $$v
      },
      expression: "nama_pegawai"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nilai (%)",
      "prop": "prosentase"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.prosentase),
      callback: function($$v) {
        _vm.prosentase = $$v
      },
      expression: "prosentase"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormSahamPegawai = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmEdit8(0, _vm.row1, 'formAdd')
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalDel),
      expression: "loadingModalDel"
    }],
    attrs: {
      "title": "Konfirmasi",
      "visible": _vm.dialogFormWilDel,
      "width": "35%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormWilDel = $event
      }
    }
  }, [_c('h4', [_vm._v("Apakah Anda yakin akan menghapus " + _vm._s(_vm.nama) + "?")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormWilDel = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmDel1()
      }
    }
  }, [_vm._v("Ya")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Info",
      "visible": _vm.dialogFormInfo,
      "width": "35%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormInfo = $event
      }
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormInfo = false
      }
    }
  }, [_vm._v("OK")])], 1)])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77fd2988!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/master_data/Pnl1.vue
// module id = 1411
// module chunks = 2